import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import { withRouter } from "react-router-dom";
import { config } from '../Constants';
import helpers from '../Function';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";
import { ExcelRenderer } from 'react-excel-renderer';
import moment from 'moment';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import { Button, Upload } from "antd";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class EmergencyCall extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            jwt: jwt,
            user_permission: user_permission,
            userid: user_id,
            create_by: name,
            create_by_id: user_id,
            miss_suc: helpers.getUserType(user_type, "suc"),
            miss_su: helpers.getUserType(user_type, "su"),
            src_project: "",
            src_name: "",
            src_department: "",
            src_position: "",
            src_phone: "",
            src_department_en: "",
            src_name_en: "",
            add_id: "",
            val_project: "",
            add_project: "",
            add_name: "",
            add_name_en: "",
            add_department: "",
            add_department_en: "",
            add_position: "",
            add_phone: "",
            add_line: "",
            add_seq: "",
            add_active_status: "",
            active: 1,
            project_home: [],
            pages: [],
            page: 0,
            rowsPerPage: 10,
            //take import
            importIsOpen: false,
            rows: [],
            IsVerify: false,
            import_projectname: '',
            import_department_th: '',
            import_department_en: '',
            import_name_th: '',
            import_name_en: '',
            import_tel: '',
            import_lineid: '',
            import_no: '',
            import_activestatus: '',
        }

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.closeAdd = this.closeAdd.bind(this);
        this.closeSrc = this.closeSrc.bind(this);
        this.closeModelUpdate = this.closeModelUpdate.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.change = this.change.bind(this);
        this.openView = this.openView.bind(this);
        this.openEdit = this.openEdit.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.openDelete = this.openDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.onChange = this.onChange.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)

        this.openImport = this.openImport.bind(this)
        this.closeImport = this.closeImport.bind(this)
        this.submitImport = this.submitImport.bind(this)
        this.submitVerify = this.submitVerify.bind(this)

        this.dataTable();
        this.project_home()

        // const requestOptions = {
        //     method: 'GET',
        //     headers: {
        //         Accept: 'application/json',
        //         'Content-Type': 'application/json',
        //         'Authorization': jwt,
        //     },
        // };

        // fetch(config.url.API_URL + '/project_homes', requestOptions)
        //     .then(res => res.json())
        //     .then(data => {
        //         // store user details and jwt token in local storage to keep user logged in between page refreshes
        //         //alert(data.status);
        //         let sortData = data.data.sort(function (a, b) {
        //             return a.num - b.num;
        //         });

        //         var found = sortData.filter(function (item) { return item.active; });
        //         var found2 = found.filter(function (item) { return !item.delete; });

        //         let FromApi = found2.map(data => {
        //             return { value: data.id, display: data.name_th }
        //         });

        //         this.setState({
        //             project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
        //         });

        //     });
    }

    project_home() {
        try {
            let body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                body = `?projecthomeid=${this.state.PROJECTID}`
                fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
            } else {
                fetch(config.url.API_URL + '/project_homes/', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID && this.state.src_project == '') {
                this.state.src_project = this.state.PROJECTID
            }
    
            fetch(config.url.API_URL + '/emergencycall/?projecthomeid=' + (this.state.src_project ? this.state.src_project : '')
                + '&name=' + (this.state.src_name ? this.state.src_name : '')
                + '&name_en=' + (this.state.src_name_en ? this.state.src_name_en : '')
                + '&position=' + (this.state.src_position ? this.state.src_position : '')
                + '&department=' + (this.state.src_department ? this.state.src_department : '')
                + '&department_en=' + (this.state.src_department_en ? this.state.src_department_en : '')
                + '&phone=' + (this.state.src_phone ? this.state.src_phone : '')
                + '&line_id=' + (this.state.src_line ? this.state.src_line : '')
                , requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        var FromApi = data.data.map(datas => {
                            var project_homes_name = '';
                            if (datas.project_homes.length) {
                                project_homes_name = datas.project_homes[0].name_th;
                            }
                            return {
                                id: datas._id,
                                project_name: project_homes_name,
                                name: datas.name,
                                name_en: datas.name_en,
                                position: datas.position,
                                department: datas.department,
                                department_en: datas.department_en,
                                phone: datas.phone,
                                line_id: datas.line_id,
                                created: moment(datas.created).format("DD/MM/YYYY"),
                                active_status: helpers.getActiveStatus(datas.active_status + ""),
                                updateby: datas.updateby != undefined ? datas.updateby : datas.createby,
                                updated: datas.updated != undefined ? `${moment(datas.updated).format("DD/MM/YYYY HH:mm น.")}` : `${moment(datas.created).format("DD/MM/YYYY HH:mm น.")}`,
                            }
                        });
                        //alert(FromApi.length);
                        this.setState({
                            pages: [].concat(FromApi),
                            srcIsOpen: false
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/emergencycall/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var datas = dataMain.data[0];
                    this.setState({
                        add_id: datas._id,
                        add_name: datas.name,
                        add_name_en: datas.name_en,
                        add_position: datas.position,
                        add_department: datas.department,
                        add_department_en: datas.department_en,
                        add_phone: datas.phone,
                        add_line: datas.line_id,
                        add_seq: datas.seq,
                        add_project: (datas.project_homes[0] === undefined ? "" : datas.project_homes[0].name_th),
                        add_active_status: helpers.getActiveStatus(datas.active_status + "")
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    async openEdit(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/emergencycall/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(async dataMain => {
                    var datas = dataMain.data[0];
                    this.setState({
                        add_id: datas._id,
                        add_name: datas.name,
                        add_name_en: datas.name_en,
                        add_position: datas.position,
                        add_department: datas.department,
                        add_department_en: datas.department_en,
                        add_phone: datas.phone,
                        add_line: datas.line_id,
                        add_seq: datas.seq,
                        add_project: (datas.project_homes[0] === undefined ? "" : datas.project_homes[0].name_th),
                        val_project: datas.project_home_id,
                        active: datas.active_status == 1 ? true : false,
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitEdit(e) {
        try {
                    // if (!this.state.add_name) {
        //     alert('ไม่พบข้อมูลชื่อ');
        //     return;
        // }

        // if (!this.state.add_position) {
        //     alert('ไม่พบข้อมูลตำแหน่ง');
        //     return;
        // }

        if (!this.state.val_project) {
            alert('ไม่พบข้อมูลโครงการ');
            return;
        }

        if (!this.state.add_department) {
            alert('ไม่พบข้อมูลหน่วยงาน');
            return;
        }

        if (!this.state.add_department_en) {
            alert('ไม่พบข้อมูลหน่วยงาน');
            return;
        }

        if (!this.state.add_phone) {
            alert('ไม่พบข้อมูลเบอร์โทรศัพท์');
            return;
        }

        const requestOptions = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                name: this.state.add_name,
                name_en: this.state.add_name_en,
                position: this.state.add_position,
                department: this.state.add_department,
                department_en: this.state.add_department_en,
                phone: this.state.add_phone,
                line_id: this.state.add_line,
                seq: this.state.add_seq,
                project_home_id: this.state.val_project,
                active_status: this.state.active ? 1 : 0,
                updateby: this.state.create_by,
                updateby_id: this.state.create_by_id
            })
        };

        fetch(config.url.API_URL + '/emergencycall/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updateIsOpen: true,
                    addIsOpen: false
                });
            }).catch(error => {
                console.log(error)
                //window.location.reload(); // Reload the page
            });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_name: '',
            add_name_en: "",
            add_position: '',
            add_department: '',
            add_department_en: '',
            add_phone: '',
            add_line: "",
            add_seq: "",
            active: true,
            file: null
        });

    }

    closeAdd() {
        this.setState({
            add_name: '',
            add_name_en: '',
            add_position: '',
            add_department: '',
            add_department_en: "",
            add_phone: '',
            add_project: '',
            val_project: '',
            add_line: "",
            add_seq: "",
            active: true
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({
            updateIsOpen: false,
            add_title: '',
            val_project: ''
        });
        this.dataTable();
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    submitAdd() {
        try {
                    // if (!this.state.add_name) {
        //     alert('ไม่พบข้อมูลชื่อ');
        //     return;
        // }

        // if (!this.state.add_position) {
        //     alert('ไม่พบข้อมูลตำแหน่ง');
        //     return;
        // }

        if (!this.state.val_project) {
            alert('ไม่พบข้อมูลโครงการ');
            return;
        }

        if (!this.state.add_department) {
            alert('ไม่พบข้อมูลหน่วยงาน');
            return;
        }

        if (!this.state.add_department_en) {
            alert('ไม่พบข้อมูลหน่วยงาน');
            return;
        }

        if (!this.state.add_phone) {
            alert('ไม่พบข้อมูลเบอร์โทรศัพท์');
            return;
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                name: this.state.add_name,
                name_en: this.state.add_name_en,
                position: this.state.add_position,
                department: this.state.add_department,
                department_en: this.state.add_department_en,
                phone: this.state.add_phone,
                line_id: this.state.add_line,
                seq: this.state.add_seq,
                project_home_id: this.state.val_project,
                active_status: this.state.active ? 1 : 0,
                updateby: this.state.create_by,
                updateby_id: this.state.create_by_id
            })
        };

        fetch(config.url.API_URL + '/emergencycall', requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updateIsOpen: true
                });
            }).catch(error => {
                console.log(error)
                //window.location.reload(); // Reload the page
            });

        this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            add_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'DELETE',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/emergencycall/' + this.state.add_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        add_id: ''
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ deleteIsOpen: false });

        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_project: "",
            src_name: "",
            src_name_en:"",
            src_department: "",
            src_department_en: "",
            src_position: "",
            src_phone: "",
            src_line: "",
            page: 0
        });
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    changeStartDate = date => {
        this.setState({
            add_transfer_date: date
        });
    }


    fileHandler2 = fileList => {
        console.log("fileList", fileList);
        let fileObj = fileList;
        if (!fileObj) {
            this.setState({
                errorMessage: "No file uploaded!"
            });
            return false;
        }
        console.log("fileObj.type:", fileObj.type);
        if (
            !(
                fileObj.type === "application/vnd.ms-excel" ||
                fileObj.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            )
        ) {
            this.setState({
                errorMessage: "Unknown file format. Only Excel files are uploaded!"
            });
            return false;
        }
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            } else {
                let newRows = [];
                resp.rows.slice(1).map((row, index) => {
                    if (row.length > 0 && row !== "undefined") {
                        newRows.push({
                            key: index,
                            import_projectname: row[1],
                            import_department_th: row[2],
                            import_department_en: row[3],
                            import_name_th: row[4],
                            import_name_en: row[5],
                            import_tel: row[6],
                            import_lineid: row[7],
                            import_no: row[8],
                            import_activestatus: row[9],
                        });
                    }
                }, {});
                if (newRows.length === 0) {
                    this.setState({
                        errorMessage: "No data found in file!"
                    });
                    return false;
                } else {
                    this.setState({
                        rows: newRows,
                        errorMessage: null
                    });
                }
            }
        });
        return false;
    };

    openImport() {
        this.setState({
            importIsOpen: true,
            rows: [],
            errorMessage: null,
            IsVerify: false
        });
    }

    closeImport() {
        this.setState({
            importIsOpen: false,
        });
    }

    submitImport() {
        try {
            if (this.state.rows.length < 1) {
                alert("ไม่มีข้อมูลการ import")
                return
            }
            
            if(!this.state.IsVerify){
                alert("กรุณาตรวจสอบข้อมูล")
                return
            }
    
            this.setState({
                importIsOpen: false,
                spinner: true
            });
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    import_data: this.state.rows,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
    
                })
            };
    
            fetch(config.url.API_URL + '/import_emergencycall', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        importIsOpen: false,
                        updateIsOpen: true,
                        spinner: false
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
                // .then(data => {
                //     this.setState({
                //         //importIsOpen: false,
                //         updateIsOpen: true,
                //         spinner: false
                //     });
                // });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitVerify() {
        try {
            if (this.state.rows.length < 1) {
                alert("ไม่มีข้อมูลการ import")
                return
            }
            
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    import_data: this.state.rows,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
    
                })
            };
    
            fetch(config.url.API_URL + '/verifyimport_emergencycall', requestOptions)
                .then(res => res.json())
                .then(data => {
    
                    if(data.status == "Success"){
                        const dataArr = data.data
                        data.error > 0 ? document.getElementById('submitImport').disabled = true : document.getElementById('submitImport').disabled = false
                        this.setState({
                            rows: dataArr,
                            errorMessage: null,
                            IsVerify: true
                        });
                    }else{
                        this.setState({
                            rows: [],
                            errorMessage: null,
                            IsVerify: false
                        });
                        alert('เกิดข้อผิดพลาด')
                    }
    
                    // var dataArr = data.data
                    // if (dataArr) {
                    //     alert("ตรวจสอบเรียบร้อย")
                    //     this.setState({
                    //         rows: dataArr,
                    //         errorMessage: null,
                    //         IsVerify: true
                    //     });
                    // }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Emergency Call</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Emergency Call</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {(this.state.user_permission[157].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                    {/* <div className="btn-add text-center" width={"500px"}><a href={'https://admin.nvdsmarthome.com/downloadFile/import_emergency.xlsx'} style={{ color: 'black' }} >ตัวอย่างหลายรายการ</a></div> */}
                                    <div className="btn-add text-center" width={"500px"}><a href={`${config.url.API_URL}/downloadFile/emergencycall_template.xlsx`} style={{ color: 'black' }}>Download Template</a></div>
                                    <div className="btn-add text-center" onClick={this.openImport}>Import</div>
                                    <ExcelFile filename="emergency" element={(
                                        <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="emergency">
                                            <ExcelColumn label="โครงการ" value={(col) => col.project_name} />
                                            <ExcelColumn label="หน่วยงาน" value={(col) => col.department} />
                                            <ExcelColumn label="ชื่อ" value={(col) => col.name} />
                                            <ExcelColumn label="โทรศัพท์" value={(col) => col.phone} />
                                            <ExcelColumn label="line" value={(col) => col.line_id} />
                                            <ExcelColumn label="วันที่สร้าง" value={(col) => col.created} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(เวลา)" value={(col) => col.updated} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: '100px' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หน่วยงาน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>โทรศัพท์</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>วันที่สร้าง</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: '200px' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.department}</StyledTableCell>
                                                                    <StyledTableCell>{data.phone}</StyledTableCell>
                                                                    <StyledTableCell>{data.created}</StyledTableCell>
                                                                    <StyledTableCell>{data.active_status}</StyledTableCell>
                                                                    <StyledTableCell>{data.updateby}<br />{data.updateby != undefined ? data.updated : ""}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                        {(this.state.user_permission[158].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                        )}
                                                                        {(this.state.user_permission[159].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        )}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ :</div>
                                <div className="col-5">
                                    <select className="form-control" id="src_project" name="src_project" style={{ height: 45 }} onChange={this.change}>
                                        {this.state.project_home.map((datas, i) => <option key={i} value={datas.value}>{datas.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">หน่วยงาน</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_department" name="src_department" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ตำแหน่ง</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_position" name="src_position" onChange={this.change} />
                                </div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หน่วยงานไทย</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_department" name="src_department" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หน่วยงานอังกฤษ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_department_en" name="src_department_en" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อไทย</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_name" name="src_name" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่ออังกฤษ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_name_en" name="src_name_en" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โทรศัพท์</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_phone" name="src_phone" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Line Id</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_line" name="src_line" onChange={this.change} />
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-5">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" id="val_project" name="val_project" style={{ height: 45 }} onChange={this.change}>
                                            {this.state.project_home.map((datas) =>
                                                <option value={datas.value} selected={this.state.val_project === datas.value && "selected"}>{datas.display}</option>
                                            )}
                                        </select>) : (<div className="form-control">{this.state.add_project}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หน่วยงานไทย<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_department" name="add_department" defaultValue={this.state.add_department} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_department}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หน่วยงานอังกฤษ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_department_en" name="add_department_en" defaultValue={this.state.add_department_en} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_department_en}</div>)}
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">ตำแหน่ง<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_position" name="add_position" defaultValue={this.state.add_position} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_position}</div>)}
                                </div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อไทย</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_name" name="add_name" defaultValue={this.state.add_name} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่ออังกฤษ</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_name_en" name="add_name_en" defaultValue={this.state.add_name_en} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name_en}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โทรศัพท์<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_phone" name="add_phone" defaultValue={this.state.add_phone} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_phone}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Line Id</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_line" name="add_line" defaultValue={this.state.add_line} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_line}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ลำดับ</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_seq" name="add_seq" defaultValue={this.state.add_seq} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_seq}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.importIsOpen} onHide={this.closeImport} size="xl">
                    <ModalHeader>
                        <div className="row">
                            <div className="col-sm-12">
                                <Upload name="file" beforeUpload={this.fileHandler2} onRemove={() => this.setState({ rows: [] })} multiple={false} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
                                <button className="btn btn-primary" disabled={this.state.rows.length > 0 ? true : false} > Import Excel File </button>
                                </Upload>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                {
                                                    this.state.IsVerify && <StyledTableCell style={{ width: 'auto' }}>หมายเหตุ</StyledTableCell> 
                                                }
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หน่วยงานไทย</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หน่วยงานอังกฤษ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อไทย</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่ออังกฤษ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เบอร์โทรศัพท์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>line id</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ลำดับ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.rows.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    {
                                                                        this.state.IsVerify && <StyledTableCell style={data.import_comment == 'Create' || data.import_comment == 'Update' ? { color: 'rgb(106 182 170)' } : {color: 'rgb(250, 108, 108)'}}>{data.import_comment}</StyledTableCell> 
                                                                    }
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_projectname}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_department_th}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_department_en}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_name_th}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_name_en}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_tel}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_lineid}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_no}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.import_activestatus}</StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.rows.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <button className="btn btn-warning" onClick={this.submitVerify}>ตรวจสอบข้อมูล</button>
                        &nbsp;&nbsp;
                            <button className="btn btn-danger" onClick={this.closeImport}>ยกเลิก</button>
                        &nbsp;&nbsp;
                            <button id='submitImport' className="btn btn-success" data-id={this.state.add_id} disabled={!this.state.IsVerify} onClick={this.submitImport}>ตกลง</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}